<template>
  <v-menu
    v-if="menuActive"
    ref="images-menu"
    v-model="menuActive"
    offset-x
    :open-on-click="true"
    :close-on-click="true"
    :close-on-content-click="false"
    :nudge-left="150"
    :nudge-top="50"
  >
    <template v-slot:activator="{ on }">
      <v-icon
        small
        :color="hasImages ? 'green' : 'grey'"
        v-on="on"
      >
        image
      </v-icon>
    </template>
    <v-card>
      <ImagesList
        :id="shippingId"
        :resource="resource"
        :is-left="true"
        title="Добавить фото"
        :width="hasImages ? '260px' : '220px'"
        :block-height="hasImages ? '' : '50'"
        @change="changeImages"
      />
    </v-card>
  </v-menu>
  <v-icon
    v-else
    small
    :color="hasImages ? 'green' : 'grey'"
    @click="menuActive = true"
  >
    image
  </v-icon>
</template>
<script>
import ImagesList from "../../../components/images/ImagesList.vue";
export default {
  components: { ImagesList },
  props: ["shippingId", "resource", "hasImagesInItem"],
  data() {
    return {
      menuActive: false,
      hasImages: false,
    };
  },
  created() {
    this.hasImages = this.hasImagesInItem;
  },
  mounted() {
    this.$watch(
      () => {
        return this.menuActive;
      },
      newVal => {
        if (newVal) {
          this.$refs["images-menu"].isActive = true;
        }
      },
    );
  },
  methods: {
    changeImages(value) {
      if (!value.length) {
        this.hasImages = false;
      } else {
        this.hasImages = true;
      }
    },
  },
};
</script>
